"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.Tabs = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _classnames = _interopRequireDefault(require("classnames"));
var _Tab = _interopRequireWildcard(require("./Tab"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Primary UI component for Tabs
 * Accepts optional `children` prop, an array or list of children to be displayed when the corresponding tab is active
 * Alternatively state & tab content display can be handled within the parent component.
 */

const Tabs = ({
  data: {
    tabs
  },
  config: {
    Link = _reactRouterDom.Link,
    onChangeTab,
    initialTabIndex,
    fullWidth,
    alignTabs = 'left',
    alignTabLabel = 'left',
    minTabWidth,
    maxTabWidth,
    contentAsCard,
    persistContent = true
  },
  className,
  children,
  ...props
}) => {
  const [tabIndex, setTabIndex] = (0, _react.useState)(initialTabIndex || 0);
  const onClickTab = i => {
    if (i !== tabIndex) {
      if (onChangeTab) onChangeTab(tabs[i], i);
      setTabIndex(i);
    }
  };
  (0, _react.useEffect)(() => {
    // Detect change to initialTabIndex
    if (typeof initialTabIndex === 'number') {
      setTabIndex(initialTabIndex);
    }
  }, [initialTabIndex]);
  const renderTabContent = (content, visible) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _classnames.default)('ccl-l-tabs__content__inner', {
      'ccl-l-tabs__content__inner--hidden': !visible
    }),
    children: content
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _classnames.default)('ccl-l-tabs', className || ''),
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "ccl-l-tabs__rowWrapper",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classnames.default)('ccl-l-tabs__tabs-row', {
          [`ccl-l-tabs__tabs-row--align--${alignTabs}`]: alignTabs
        }),
        children: tabs.map((tab, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tab.default, {
          tab: tab,
          active: tabIndex === i,
          fullWidth: fullWidth,
          onClick: () => onClickTab(i),
          Link: Link,
          alignTabLabel: alignTabLabel,
          minTabWidth: minTabWidth,
          maxTabWidth: maxTabWidth
        }, i))
      })
    }), children && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classnames.default)('ccl-l-tabs__content', {
        'ccl-l-tabs__content--card': contentAsCard
      }),
      children: persistContent ? children.map((child, i) => renderTabContent(child, i === tabIndex)) : renderTabContent(children[tabIndex], true)
    })]
  });
};
exports.Tabs = Tabs;
Tabs.defaultProps = {
  config: {
    initialTabIndex: 0,
    fullWidth: false,
    alignTabs: 'left',
    alignTabLabel: 'left'
  }
};